import React from 'react'
import { createUseStyles } from "react-jss";

function DashboardBanner({ companyHeader }) {
    const styles = useStyles();
    return (
        <>
            <img src={
                companyHeader ? companyHeader :
                "https://cdn.hireside.com/cdn/images/Social/LinkedIn_Header.jpg"
            } className={styles.companyHeaderImage}>
            </img>
        </>
    )
}

const useStyles = createUseStyles({
    companyHeaderImage: {
        width: "100%",
        height: "100%",
        borderRadius: "15px",
        marginBottom: "25px",
    },
});

export default DashboardBanner